import { cn } from "../../../lib/utils.js";

const SKELETON_NAME_WIDTHS = [
  "w-[58%]",
  "w-[44%]",
  "w-[66%]",
  "w-[50%]",
  "w-[38%]",
  "w-[62%]",
  "w-[47%]",
  "w-[55%]",
] as const;

/** Loading rows with the same 64px geometry as real rows, so nothing jumps when data lands. */
export function ConversationRowSkeleton({
  rows = 8,
  label,
}: {
  rows?: number;
  label: string;
}): React.JSX.Element {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      data-testid="inbox-list-loading"
      className="min-h-0 flex-1 overflow-hidden bg-inbox-rows pt-1.5"
    >
      <span className="sr-only">{label}</span>
      {Array.from({ length: rows }, (_, index) => (
        <div key={index} className="mx-2 my-0.5 flex h-16 items-center gap-2.5 px-2.5 py-[9px]" aria-hidden="true">
          <span className="size-[2.375rem] shrink-0 animate-pulse rounded-full bg-inbox-line-soft motion-reduce:animate-none" />
          <span className="flex min-w-0 flex-1 flex-col gap-2">
            <span
              className={cn(
                "h-3 animate-pulse rounded-lg bg-inbox-line-soft motion-reduce:animate-none",
                SKELETON_NAME_WIDTHS[index % SKELETON_NAME_WIDTHS.length],
              )}
            />
            <span className="h-2.5 w-[82%] animate-pulse rounded-lg bg-inbox-line-soft motion-reduce:animate-none" />
          </span>
        </div>
      ))}
    </div>
  );
}
